import { useUser } from "@tm/context-distribution"
import { UserModule, UserModuleType } from "@tm/models"

export const useTelesalesModule = (): UserModule | null => {
    const userContext = useUser()?.userContext

    return userContext?.modules?.find((x) => x.type === UserModuleType.Telesales) || null
}
